"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
var VButton_vue_1 = __importDefault(require("../scraps/VButton.vue"));
var VConfirmationModal_vue_1 = __importDefault(require("../scraps/VConfirmationModal.vue"));
var event_bus_1 = require("../../event-bus");
var vue_class_component_1 = __importDefault(require("vue-class-component"));
var vue_property_decorator_1 = require("vue-property-decorator");
var VIcon_vue_1 = __importDefault(require("../scraps/VIcon.vue"));
var ArchiveScout = /** @class */ (function (_super) {
    __extends(ArchiveScout, _super);
    function ArchiveScout() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = "archive-scout";
        _this.showModal = false;
        return _this;
    }
    Object.defineProperty(ArchiveScout.prototype, "scoutName", {
        get: function () {
            return this.scout.first_name + " " + this.scout.last_name;
        },
        enumerable: true,
        configurable: true
    });
    ArchiveScout.prototype.onOk = function () {
        this.showModal = false;
        event_bus_1.EventBus.$emit(event_bus_1.events.scout.archive, this.scout);
    };
    __decorate([
        vue_property_decorator_1.Prop({ required: true })
    ], ArchiveScout.prototype, "scout", void 0);
    ArchiveScout = __decorate([
        vue_class_component_1.default({ components: {
                VButton: VButton_vue_1.default,
                VConfirmationModal: VConfirmationModal_vue_1.default,
                VIcon: VIcon_vue_1.default
            } })
    ], ArchiveScout);
    return ArchiveScout;
}(vue_1.default));
exports.default = ArchiveScout;
